export const iconsList = [
	{ icon: "fas fa-arrow-down", toggle: "fas fa-arrow-up" },
	{ icon: "fas fa-arrow-circle-down", toggle: "fas fa-arrow-circle-up" },
	{
		icon: "fas fa-arrow-alt-circle-down",
		toggle: "fas fa-arrow-alt-circle-up",
	},
	{
		icon: "far fa-arrow-alt-circle-down",
		toggle: "far fa-arrow-alt-circle-up",
	},
	{ icon: "fas fa-expand-arrows-alt", toggle: "fas fa-compress-arrows-alt" },
	{ icon: "fas fa-chevron-down", toggle: "fas fa-chevron-up" },
	{ icon: "fas fa-chevron-right", toggle: "fas fa-chevron-left" },
	{ icon: "fas fa-chevron-circle-down", toggle: "fas fa-chevron-circle-up" },
	{ icon: "fas fa-caret-down", toggle: "fas fa-caret-up" },
	{ icon: "fas fa-caret-square-down", toggle: "fas fa-caret-square-up" },
	{ icon: "far fa-caret-square-down", toggle: "far fa-caret-square-up" },
	{ icon: "fas fa-angle-down", toggle: "fas fa-angle-up" },
	{ icon: "fas fa-angle-double-down", toggle: "fas fa-angle-double-up" },
	{ icon: "fas fa-expand-alt", toggle: "fas fa-compress-alt" },
];